// empty string
export const EMPTY_VALUE = '-';

// length
export const OTP_LENGTH = 6;

// timing: in seconds
export const ONE_MINUTE = 60;
export const TWO_MINUTES = 120;

// timing: in milliseconds
export const ONE_SECOND = 1000;
export const TWO_SECONDS = 2000;
export const THREE_SECONDS = 3000;
export const FOUR_SECONDS = 4000;
export const ONE_MINUTE_MS = 60 * ONE_SECOND;
export const FIVE_MINUTES_MS = 5 * ONE_MINUTE_MS;

// MAXIMUM
export const MAX_NOTIFY_TIME_OUT = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
};
